var _mask, _g, _mask2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlustraDesconectado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 23,
    width: 154,
    height: 154
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.145 99.95c0 42.296 34.286 76.581 76.58 76.581 42.295 0 76.581-34.285 76.581-76.58S142.02 23.37 99.725 23.37c-42.294 0-76.58 34.286-76.58 76.58",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.368 100.225c0 46.206-41.812 83.664-93.39 83.664s-93.39-37.458-93.39-83.664c0-46.207 41.812-83.664 93.39-83.664s93.39 37.457 93.39 83.664",
    fill: "#F4A3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.86 104.107h-40.488c-4.599 0-8.362-3.763-8.362-8.362V55.257c0-4.6 3.763-8.362 8.362-8.362h40.488c4.599 0 8.362 3.763 8.362 8.362v40.488c0 4.599-3.763 8.362-8.362 8.362",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.599 75.502c0 8.276-6.708 14.984-14.983 14.984-8.276 0-14.985-6.708-14.985-14.984 0-8.275 6.709-14.984 14.985-14.984 8.275 0 14.983 6.71 14.983 14.984",
    fill: "#FFF6B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 60.309a14.953 14.953 0 0 0-11.589 5.487 14.92 14.92 0 0 1 9.498-3.397c8.275 0 14.984 6.709 14.984 14.984 0 3.606-1.275 6.913-3.396 9.498a14.952 14.952 0 0 0 5.487-11.588c0-8.276-6.709-14.984-14.984-14.984",
    fill: "#F3E9A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.616 79.148a1.93 1.93 0 1 1-.001 3.86 1.93 1.93 0 0 1 .001-3.86M142.616 67.998a1.93 1.93 0 1 1-.001 3.859 1.93 1.93 0 0 1 .001-3.86",
    fill: "#908961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.17 127.454c-.398 5.656-.626 11.75 2.887 16.558 2.846 3.896 7.158 5.358 11.835 4.436 6.474-1.275 12.402-5.542 19.217-5.088 6.317.422 12.285 6.127 7.712 12.332-4.064 5.515-12.139 5.687-18.322 6.423-7.058.839-14.125 1.6-21.183 2.446-13.81 1.654-27.584 3.651-41.085 7.048-2.174.547-1.253 3.908.926 3.36 11.686-2.941 23.582-4.849 35.53-6.356 11.353-1.431 22.887-2.162 34.163-4.113 7.396-1.279 17.163-6.628 14.865-15.732-1.985-7.864-11.388-9.779-18.228-8.337-5.678 1.198-12.969 6.35-18.806 4.469-6.991-2.253-6.43-11.713-6.026-17.446.157-2.238-3.328-2.228-3.485 0",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.214 130.924a3.643 3.643 0 0 1-3.632-3.633v-3.934a3.643 3.643 0 0 1 3.632-3.633 3.643 3.643 0 0 1 3.633 3.633v3.934a3.644 3.644 0 0 1-3.633 3.633",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.273 93.228a3.33 3.33 0 0 1-3.33-3.33V57.943a3.33 3.33 0 0 1 6.66 0V89.9a3.33 3.33 0 0 1-3.33 3.33M79.154 93.228a3.33 3.33 0 0 1-3.33-3.33V57.943a3.33 3.33 0 0 1 6.66 0V89.9a3.33 3.33 0 0 1-3.33 3.33",
    fill: "#FFF6B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.194 87.16c0-2.764-2.261-5.025-5.025-5.025H73.26c-2.763 0-5.024 2.261-5.024 5.024 0 2.389 1.692 4.4 3.935 4.901v23.208c0 4.6 3.764 8.363 8.363 8.363h15.362c4.6 0 8.363-3.763 8.363-8.363V92.06c2.243-.502 3.935-2.512 3.935-4.9",
    fill: "#49494A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.654 115.268V92.059c-2.244-.5-3.935-2.511-3.935-4.9 0-2.764 2.26-5.024 5.023-5.024h-3.484c-2.763 0-5.024 2.26-5.024 5.024 0 2.389 1.692 4.4 3.936 4.9v23.209c0 4.6 3.763 8.363 8.362 8.363h3.484c-4.6 0-8.362-3.763-8.362-8.363",
    fill: "#3F4040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.189 92.221a.042.042 0 0 0-.006-.014c-.002-.005-.005-.01-.009-.014a.07.07 0 0 0-.008-.014.098.098 0 0 0-.012-.013l-.003-.003c0-.002-.001-.003-.003-.005a.055.055 0 0 0-.014-.007l-.016-.007a.288.288 0 0 0-.021-.011l-.024-.01-.028-.01-.028-.006-.029-.006a.289.289 0 0 0-.03-.006l-.034-.004-.036-.001-.022-.003a.114.114 0 0 0-.022-.002H73.507a.67.67 0 0 0-.246.042c-.064.026-.103.062-.103.101 0 .02.01.04.029.057a.225.225 0 0 0 .076.045l.46 2.594.46 2.595c-.04.022-.065.048-.07.076-.006.027.008.055.043.08a.365.365 0 0 0 .13.054.768.768 0 0 0 .344 0s-3.95 1.153 2.1-2.308c2.554-1.461 21.284-3.068 21.284-3.068a.087.087 0 0 0 .017-.006l.017-.006a.383.383 0 0 0 .055-.019c.007-.003.013-.008.02-.01l.016-.012.017-.012a.116.116 0 0 0 .013-.013.058.058 0 0 0 .01-.014l.005-.015a.03.03 0 0 1 .005-.009c.001-.003.003-.005.003-.009 0-.001 0-.002-.002-.003a.01.01 0 0 1-.001-.004",
    fill: "#3F4040"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h200v200H0V0Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    fill: "#D91C5C"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.78 120.801a6.365 6.365 0 0 0 6.357 6.357 6.364 6.364 0 0 0 6.357-6.357 6.364 6.364 0 0 0-6.357-6.358 6.365 6.365 0 0 0-6.358 6.358Zm1.393 0a4.969 4.969 0 0 1 4.964-4.964 4.969 4.969 0 0 1 4.963 4.964 4.968 4.968 0 0 1-4.963 4.963 4.969 4.969 0 0 1-4.964-4.963Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.514 153.479a2.802 2.802 0 1 1-5.605 0 2.802 2.802 0 0 1 5.605 0M114.596 144.431l-3.45-1.681 1.68-3.449a1.047 1.047 0 0 0-1.879-.917l-1.681 3.451-3.45-1.681a1.047 1.047 0 0 0-.916 1.881l3.45 1.68-1.68 3.45a1.047 1.047 0 0 0 .939 1.503c.387 0 .759-.215.94-.587l1.681-3.451 3.45 1.68a1.046 1.046 0 0 0 .916-1.879"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustraDesconectado);
export default __webpack_public_path__ + "static/media/ilustra-desconectado.4a0c501ab05e28be38f4c7c24699cdfc.svg";
export { ForwardRef as ReactComponent };